import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './LandingPage.css'; // Re-use LandingPage styles or add new ones here

const EquipmentDropdown = ({ equipmentData, isLoggedIn, onAction }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useLanguage();

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleItemClick = (category) => {
        const targetPath = `/equipment/${category}`;
        if (onAction) {
            onAction(targetPath);
        } else if (isLoggedIn) {
            navigate(targetPath);
        } else {
            navigate('/login', { state: { from: targetPath, role: 'client' } });
        }
        setIsOpen(false);
    };

    const handleViewAll = () => {
        const targetPath = '/general-equipment-rentals';
        if (onAction) {
            onAction(targetPath);
        } else {
            navigate(targetPath);
        }
        setIsOpen(false);
    };

    return (
        <div
            className="relative ml-6"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                className="flex items-center gap-2 text-white font-bold text-lg hover:text-[#F9B101] transition focus:outline-none"
                onClick={toggleDropdown}
            >
                {t('equipmentRentals')}
                {isOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-80 bg-white text-gray-800 rounded-xl shadow-xl py-3 z-50 animate-in fade-in slide-in-from-top-2 border border-gray-100">
                    <div className="absolute -top-2 left-6 w-4 h-4 bg-white transform rotate-45 border-l border-t border-gray-100"></div>
                    <div className="flex flex-col">
                        {equipmentData.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => handleItemClick(item.category)}
                                className="text-left px-5 py-3 hover:bg-[#F9B101]/15 hover:text-[#9B6E00] transition font-medium text-sm border-b border-gray-50 last:border-none flex justify-between items-center group"
                            >
                                {item.title}
                                <span className="opacity-0 group-hover:opacity-100 transition-opacity text-[#9B6E00]">→</span>
                            </button>
                        ))}
                        <div className="p-2 mt-1">
                            <button
                                onClick={handleViewAll}
                                className="w-full bg-black text-white py-2 rounded-lg text-xs font-bold uppercase tracking-wide hover:bg-gray-800 transition"
                            >
                                {t('viewAllEquipment')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EquipmentDropdown;
